import * as cookie from 'cookie';
import { redirect } from 'react-router';

import { HORIZON_ENABLED } from '#/rendering/state/renderingState';
import { analyticsQueryParamKeys } from '#/utils/analytics/setup/configureAnalyticsUserData';
import { getFlashMessageId } from '#/zustand-stores/flashMessagesStore';

type Args = {
  request: Request;
};

type Options = {
  flashMessage?: Omit<FlashMessageType, 'id'>;
  status: number;
};

export function idealistRedirect({ request }: Args) {
  return (url: string, options?: Options) => {
    const twoDaysFromNow = new Date();
    twoDaysFromNow.setDate(twoDaysFromNow.getDate() + 2);

    const headers: Record<string, string> = {};

    // horizon-flash-message is only consumed on horizon
    //
    // We don't use the regular flashMessages for horizon
    // because it causes hydration errors, and it relies on
    // atob which has some strange bugs such as crashing when
    // serializing the JSON for `{ type: 'FORBIDDEN' }` flash message
    if (HORIZON_ENABLED && options?.flashMessage) {
      headers['Set-Cookie'] = cookie.serialize(
        'horizon-flash-message',
        JSON.stringify({ ...options.flashMessage, id: getFlashMessageId() }),
        { path: '/', expires: twoDaysFromNow },
      );
    }

    const currentUrl = new URL(request.url);
    const newUrl = new URL(url, currentUrl.origin);

    for (const param of analyticsQueryParamKeys) {
      if (currentUrl.searchParams.has(param))
        newUrl.searchParams.set(
          param,
          currentUrl.searchParams.get(param) ?? '',
        );
    }

    return redirect(newUrl.toString(), { headers });
  };
}
